import { Route } from "@angular/router";
import { EADDetalhePage } from "./ead-detalhe.page";

export const EADDetalheRouter: Route[] = [
  { path: 'ead-detalhe', component: EADDetalhePage }
];
